export default "__VITE_ASSET__VZpn0wpe__"